import React from "react";

const STATUS_COLORS = {
  "Pending Review": "border-amber-500/40 text-amber-300 bg-amber-500/5",
  "Research Account Only": "border-brand-navy text-brand-accent bg-brand-surface",
  "Institutional Account Only": "border-brand-navy text-brand-accent bg-brand-surface",
  "Licensed Professional Only": "border-indigo-500/40 text-indigo-300 bg-indigo-500/5",
  "Prescription Workflow Required": "border-fuchsia-500/40 text-fuchsia-300 bg-fuchsia-500/5",
  "Not Available for Sale": "border-slate-500/40 text-brand-text bg-slate-500/5",
  "Approved for Standard Checkout": "border-emerald-500/40 text-emerald-300 bg-emerald-500/5",
};

const CHECKOUT_COLORS = {
  "Request Availability": "border-amber-500/40 text-amber-300 bg-amber-500/5",
  "Contact for Availability": "border-amber-500/40 text-amber-300 bg-amber-500/5",
  "Apply for Account": "border-brand-navy text-brand-accent bg-brand-surface",
  "Login to Purchase": "border-brand-navy text-brand-accent bg-brand-surface",
  "Add to Cart": "border-emerald-500/40 text-emerald-300 bg-emerald-500/5",
  "In Stock": "border-emerald-500/40 text-emerald-300 bg-emerald-500/5",
  "Prescription Required": "border-fuchsia-500/40 text-fuchsia-300 bg-fuchsia-500/5",
  "Temporarily Unavailable": "border-slate-500/40 text-brand-text bg-slate-500/5",
  "Out of Stock": "border-slate-500/40 text-brand-text bg-slate-500/5",
};

// Public-facing label overrides — internal DB values still carry legacy
// compliance/checkout labels, but customer-facing text must never use
// institutional/apply-for-account phrasing on public pages.  These
// overrides run for BOTH the compliance-status badge and the checkout
// badge; unlisted internal values fall through to their raw label.
const PUBLIC_STATUS_LABELS = {
  // compliance-status legacy labels
  "Institutional Account Only": "By Request",
  "Research Account Only":       "By Request",
  "Licensed Professional Only":  "By Request",
  // checkout legacy labels
  "Request Availability": "Contact for Availability",
  "Apply for Account":    "Contact for Availability",
  "Login to Purchase":    "Contact for Availability",
  "Add to Cart":          "In Stock",
};

export const StatusBadge = ({ status, kind = "compliance" }) => {
  const map = kind === "checkout" ? CHECKOUT_COLORS : STATUS_COLORS;
  const publicLabel = PUBLIC_STATUS_LABELS[status] || status;
  const cls = map[status] || "border-slate-500/40 text-brand-text bg-slate-500/5";
  return (
    <span
      data-testid={`status-badge-${kind}`}
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider border ${cls}`}
    >
      {publicLabel}
    </span>
  );
};
